
import Label from '~/components/common/newLabel.vue'
import Hide from '@/components/dealer/hide.vue'
export default {
  components: {
    Hide,
    Label
  },
  props: {
    executiveList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showLength: 6,
      labelMore: false,
      isShow: false,
      isUnfold: false,
      initDataList: []
    }
  },
  computed: {
    isZh() {
      const code = this.$store.state.LanguageCode
      if (code == 'zh-cn' || code == 'zh-tw' || code == 'zh-hk' || code == 'zh') {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    // setTimeout(() => {
    //     this.initDataList = this.executiveList
    // })
  },
  async mounted() {
    await this.initData()
    console.log('this.executiveList', this.executiveList)
  },
  methods: {
    openggfn(item) {
      this.$refs.hideref.open(item.officerId, 3, () => {
        window.open(`/${this.$store.state.LanguageCode}/employee/${item?.officerId}.html`)
      })
    },
    initData() {
      this.initDocument()
      this.initDataList = this.executiveList.slice(0, this.showLength)
      if (this.executiveList.length > this.showLength) {
        this.isShow = true
      } else {
        this.isShow = false
      }
    },
    initDocument() {
      const clientWidth = document && document.documentElement && document.documentElement.clientWidth
      if (clientWidth <= 799) {
        this.showLength = 3
      }
    },
    moreClick() {
      this.isUnfold = !this.isUnfold
      if (!this.isUnfold) {
        this.initDataList = this.executiveList.slice(0, this.showLength)
      } else {
        this.initDataList = this.executiveList
      }
    }
  }
}
